module.exports = __webpack_public_path__ + "img/money.788ba6ab.png";